import React, { useState } from 'react';
import { authAPI, authToken } from '../services/api';

const LoginPage = ({ onLoggedIn }) => {
  // const [email, setEmail] = useState('admin@example.com');
  // const [password, setPassword] = useState('Admin@123');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError(null);
      const res = await authAPI.login(email, password);
      const { accessToken, refreshToken } = res.data.data;
      authToken.set(accessToken, refreshToken);
      onLoggedIn && onLoggedIn({ accessToken, refreshToken });
    } catch (e) {
      setError(e.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="brand">
          <div className="brand-title">DigiLocker Issuer</div>
          <div className="brand-sub">Secure Document Issuance Dashboard</div>
        </div>
        <ul className="feature-list">
          <li>JWT Authentication and Role-based Access</li>
          <li>Employee and Document Management</li>
          <li>DigiLocker Pull URI Testing Tools</li>
          <li>Audit Logging and Diagnostics</li>
        </ul>
      </div>
      <div className="login-right">
        <div className="login-card">
          <div className="login-logo">
            <img src={process.env.PUBLIC_URL + '/logo-login.png'} alt="Company Logo" />
          </div>
          <h2>Login</h2>
          {error && <div className="alert alert-danger">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input className="form-control" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input className="form-control" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required />
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading}>{loading ? 'Logging in...' : 'Login'}</button>
          </form>
        </div>
        <div className="login-footer">
          <p>Powered by <strong>Navantra Global Solutions Pvt. Ltd</strong></p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;


